import React, { useState} from "react";
import "./indexStyle.css";
import { Card, Form, Select, DatePicker,Button } from "antd";
import { PageContainer } from "@ant-design/pro-layout";
import { QueryFilter } from "@ant-design/pro-form";
import "react-dual-listbox/lib/react-dual-listbox.css";
import services from "../services";
import "react-dual-listbox/lib/react-dual-listbox.css";
import { Permissions } from "../../Constantes/permissions.constants";
import { Secured } from "../../component";
import moment from "moment";

const RelatorioCensoIniciado = () => {

    const status = {
        0: "Iniciado",
        1: "Concluìdo",
        2: "Retificado",
      };

    const [filterValues, setFilterValues] = useState();

    const [isDownloading, setIsDownloading] = useState(false);

    const handleButtonClick = async (props, type) => {
       try {
            
            if (props.form) {
                props.form.submit();
            }
            const values = await props.form.validateFields();

            if (type === 'pdf') {
            handlePrintReport(values);
            } else if (type === 'csv') {
            handleDownloadCsv(values);
            }
        } catch (err) {
            console.warn("Formulário inválido. Corrija os campos antes de continuar.");
        }
    };
    

    const handlePrintReport = async (values) => {
        if (isDownloading) {
            alert("O download está em andamento. Aguarde até que termine.");
            return; 
        }

        try {
            let { dataInicio, dataFim,status } = values || {};

            dataInicio = dataInicio ? moment(dataInicio).format('YYYY-MM-DD') : null;
            dataFim = dataFim ? moment(dataFim).format('YYYY-MM-DD') : null;

            const params = { dataInicio, dataFim,status};

            if(dataInicio === null || dataInicio === undefined){
                return;
            }

            setIsDownloading(true);

            const response = await services.visualizarRelatorioCompleto(params);

            if (!response) {
                throw new Error("Resposta vazia do servidor");
            }

            const contentType = response.type || "";

            if (contentType.includes("application/json")) {
                const errorText = await response.text();
                const errorJson = JSON.parse(errorText);
                console.error("Erro ao gerar relatório:", errorJson);
                alert(errorJson.mensagem || "Erro ao gerar relatório.");
                return;
            }

            // Criar um link para baixar o PDF
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "censos_iniciados.pdf");
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            console.error("Erro inesperado ao gerar relatório:", error);
            alert("Erro inesperado ao gerar relatório.");
        } finally {
            setIsDownloading(false);
        }
    };
    
    const handleDownloadCsv = async (values) => {
        if (!values || !values.dataInicio) {
            console.error("Período inicial é obrigatório.");
            return;
        }

        let { dataInicio, dataFim,status } = values || {};

        dataInicio = dataInicio ? moment(dataInicio).format('YYYY-MM-DD') : null;
        dataFim = dataFim ? moment(dataFim).format('YYYY-MM-DD') : null;

        const params = { dataInicio, dataFim,status};

        setIsDownloading(true);

        try {
            const response =  await services.downloadRelatorioCsvCenso(params);
    
            console.log("Relatório gerado e baixado com sucesso.");
        } catch (error) {
            console.error("Erro ao gerar o relatório:", error);
        }finally {
            setIsDownloading(false);
        }
    };
    
    
    
    return (
        <>
            <Secured hasAnyRole={Permissions.RELATORIOS.TELA} isShowErro403={true}>
                <PageContainer>
                <h1>Relatório Censo(s)</h1>
                </PageContainer>
            </Secured>
            <Card
                title="Parâmetros Relatório"
                style={{
                fontSize: "20px",
                marginBottom: "10px",
                position: "relative",
                }}
            >
                <QueryFilter
                    onFinish={(values) => handleButtonClick(values, 'pdf')} // Adicionando ação para PDF
                    onReset={() => setFilterValues({ page: 0, size: 10 })}  
                    layout="vertical"
                    defaultCollapsed
                    className="filtro"
                    submitter={{
                        render: (props, dom) => (
                            <>
                                <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',  
                                    justifyContent: 'flex-start',
                                    gap: '10px',
                                    width: '100%',     
                                }}>
                                    {dom[0]} {/* Botão de limpar */}
                                    <Button type="primary" onClick={() => handleButtonClick(props, 'pdf')}style={{ flexShrink: 0 }}>
                                        Download Pdf
                                    </Button>

                                    <Button type="primary" onClick={() => handleButtonClick(props, 'csv')} style={{
                                        flexShrink: 0,
                                        backgroundColor: '#4CAF50',
                                        borderColor: '#4CAF50',
                            
                        }}>
                                        Download Excel
                                    </Button>
                                </div>
                            </>
                        ),
                    }}
                >


                <Form.Item
                    label="Período Inicial:"
                    shouldUpdate={(prevValues, curValues) => {
                    return (
                        prevValues.dataInicio !== curValues.dataInicio ||
                        prevValues.valueEnd !== curValues.valueEnd
                    );
                    }}
                >
                    {({ getFieldValue, setFieldsValue  }) => {
                    const startDatePreenchido0 = getFieldValue("dataInicio");

                    const endDatePreenchido0 = getFieldValue("dataFim");

                    return (
                        <Form.Item
                        name="dataInicio"
                        dependencies={["dataFim"]}
                        rules={[
                            {
                            required: endDatePreenchido0 && true,
                            message: "Por Favor, insira data",
                            },
                            {
                            validator: async () => {
                                if (startDatePreenchido0 === null || startDatePreenchido0 === "") {
                                return Promise.reject(
                                    new Error("Período inicial é obrigatório")
                                );
                                }
                            },
                            },
                        ]}
                        >
                        <DatePicker
                            name="dataFinalVigencia"
                            placeholder="Digite a data"
                            allowClear
                            format="DD/MM/YYYY"
                            onChange={(value) => {
                                if (!value) {
                                  setFieldsValue({ dataFim: null });
                                }
                              }}
                        />
                        </Form.Item>
                    );
                    }}
                </Form.Item>


                <Form.Item
                    label="Período Final:"
                    shouldUpdate={(prevValues, curValues) =>
                        prevValues.dataInicio !== curValues.dataInicio ||
                        prevValues.dataFim !== curValues.dataFim
                    }
                >
                    {({ getFieldValue, setFieldsValue }) => {
                        const dataInicio = getFieldValue("dataInicio");
                        const dataFim = getFieldValue("dataFim");

                        return (
                        <Form.Item
                            name="dataFim"
                            dependencies={["dataInicio"]}
                            rules={[
                            {
                                required: true,
                                message: "Período Final é obrigatório",
                            },
                            {
                                validator: async () => {
                                if (dataFim) {
                                    if (!dataInicio) {
                                    return Promise.reject(
                                        new Error("Você precisa selecionar a data inicial primeiro.")
                                    );
                                    }
                                    if (dataFim < dataInicio) {
                                    setFieldsValue({ dataFim: null });
                                    return Promise.reject(
                                        new Error("Data final não pode ser menor que a data inicial.")
                                    );
                                    }
                                    const diffDays = dataFim.diff(dataInicio, "days");

                                    if (diffDays > 90) {
                                      //setFieldsValue({ dataFim: null });
                                      return Promise.reject(
                                        new Error("O período não pode ser maior que 90 dias.")
                                      );
                                    }
                                }
                                },
                            },
                            ]}
                        >
                            <DatePicker
                            disabled={!dataInicio} // Desabilita se dataInicio não estiver preenchida
                            disabledDate={(d) => dataInicio && d.isBefore(dataInicio)}
                            />
                        </Form.Item>
                        );
                    }}
                </Form.Item>

                <Form.Item label="Status do Censo:" name="status">
                    <Select
                        placeholder="Selecione..."
                        allowClear={true}
                        options={Object.keys(status).map((key) => ({
                        label: status[key],
                        value: status[key],
                        }))}
                    />
                </Form.Item>
                
                </QueryFilter>

            </Card>
        </>
  );

};

export default RelatorioCensoIniciado;